module.exports = __webpack_public_path__ + "static/media/20181214_003415 - Copy.cbcda676.jpg";